export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
export const CHAT_API_BASE_URL = import.meta.env.VITE_CHAT_API_BASE_URL || 'https://chat.backend.staging.voicebot.studio/api/v1';
export const KB_API_BASE_URL = import.meta.env.VITE_KB_API_BASE_URL || 'https://kb.voicebot.studio';
export const DOMAIN_HOST = import.meta.env.VITE_DOMAIN_HOST || 'voicebot.studio';
export const AP_EMBED_URL = import.meta.env.VITE_AP_EMBED_URL || 'https://cdn.activepieces.com/sdk/embed/0.3.7.js';
export const AP_API_BASE_URL = `https://workflow.${import.meta.env.VITE_DOMAIN_HOST || 'voicebot.studio'}/api/v1`;
export const MCP_BASE_URL = `https://workflow.${import.meta.env.VITE_DOMAIN_HOST || 'voicebot.studio'}/api/v1/mcp/`;
export const MCP_URL_SUFFIX = import.meta.env.VITE_MCP_URL_SUFFIX || '/sse';
export const API_TIMEOUT = 30000; // 30 seconds

interface AuthTokens {
    access_token: string;
    refresh_token: string;
}

// Token management
export const getAuthTokens = (): AuthTokens | null => {
    const access_token = localStorage.getItem('access_token');
    const refresh_token = localStorage.getItem('refresh_token');
    // console.log('Getting stored tokens:', { access_token, refresh_token });
    return access_token && refresh_token ? { access_token, refresh_token } : null;
};

export const setAuthTokens = (access_token: string, refresh_token: string) => {
    // console.log('Setting tokens in localStorage:', { access_token, refresh_token });
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    // Notify other tabs about token update
    window.localStorage.setItem('auth_timestamp', Date.now().toString());
};

export const clearAuthTokens = () => {
    // console.log('Clearing tokens from localStorage');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    // Notify other tabs about token removal
    window.localStorage.setItem('auth_timestamp', Date.now().toString());
    
    // Clear MCP auth cache when auth tokens are cleared
    // Import is done here to avoid circular dependency
    import('./client').then(({ clearMcpAuthCache }) => {
        clearMcpAuthCache();
    });
};
